// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ua-z","heading":"va-z"};